(function () {
  'use strict';

  angular.module('app').component('incomingPrepaymentList', incomingPrepaymentList());

  function incomingPrepaymentList() {
    return {
      bindings: {
        item: '<',
        incomingPrepayments: '<',
        company: '<',
      },
      controller: incomingPrepaymentListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/prepayment-reports/incoming-prepayments/incoming-prepayment-list/' +
        'incoming-prepayment-list.component.html',
    };
  }

  incomingPrepaymentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    'moment',
    '$filter',
    'IncomingPrepaymentModalService',
    'IncomingPrepaymentService',
    'BookingService',
    'ReceivedPaymentService',
  ];

  function incomingPrepaymentListComponent(
    config,
    UtilService,
    $translate,
    moment,
    $filter,
    IncomingPrepaymentModalService,
    IncomingPrepaymentService,
    BookingService,
    ReceivedPaymentService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);
    vm.filterCriteria = IncomingPrepaymentService.getFilterCriteria();
    vm.dateDisplay = config.DATE_DISPLAY;

    // private properties
    // -----------------------
    $translate = $filter('translate');

    // public methods
    // -----------------------
    vm.openReceivedPaymentModal = function (incomingPrepayment) {
      let receivedPayment = {
        currency_id: vm.item.currency.id,
        client_id: vm.item.client.id,
        currency: vm.item.currency,
        user_id: vm.item.user_id,
        amount: incomingPrepayment.balance_due,

        received_payment_documents: [{
          document_date: incomingPrepayment.due_date,
          document_id: incomingPrepayment.id,
          payment_date: incomingPrepayment.due_date,
          total_price: incomingPrepayment.amount,
          newBalance: 0,
          balance: incomingPrepayment.balance_due,
          number: incomingPrepayment.incoming_consecutive,
          amount: incomingPrepayment.balance_due,
          type: 'incoming_prepayment',
        }],
      };

      let successCallback = function () {
        getPrepayments();
      };

      ReceivedPaymentService.openItemReceivedPaymentModal(
        receivedPayment,
        'create',
        vm.company,
        vm.item,
        successCallback
      );
    };

    vm.deleteIncomingPrepaymentItem = function (incomingPrepayment) {
      let successCallback = function () {
        getPrepayments();
      };

      if (validateEditDelete(incomingPrepayment, 'delete'))
        IncomingPrepaymentService.deleteIncomingPrepayment(incomingPrepayment, successCallback);
    };

    vm.saveIncomingPrepaymentItem = function (incomingPrepayment) {
      vm.formErrors = false;

      if (validatePercentage() > 100) {
        vm.serverErrors = vm.UtilService._errorMsg($translate('REACH_TOTAL_PERCENTAGE'));
        vm.formErrors = true;

        return;
      }

      incomingPrepayment.total_price = vm.item.total_price;
      incomingPrepayment.amount = vm.UtilService.roundNum(
        (incomingPrepayment.percentage / 100) * incomingPrepayment.total_price
      );

      incomingPrepayment.balance_due = vm.UtilService.roundNum(
        incomingPrepayment.amount - incomingPrepayment.receivedAmount
      );

      IncomingPrepaymentService.saveIncomingPrepayment(incomingPrepayment).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          incomingPrepayment.editItem = false;

          vm.UtilService.itemListChanged(response.id);
          getPrepayments('edit');
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    };

    vm.openAddIncomingPrepayment = function (index) {
      let successCallback = function () {
        getPrepayments();
      };

      let incomingPrepayments = angular.copy(vm.incomingPrepayments);

      IncomingPrepaymentModalService.openAddIncomingPrepayment(
        vm.item,
        index,
        incomingPrepayments,
        vm.totalPercentage,
        successCallback
      );
    };

    vm.openRelatedTransactions = function () {
      BookingService.openRelatedTransactions(vm.item, vm.item.client);
    };

    vm.editIncomingPrepayment = function (incomingPrepayment) {
      if (validateEditDelete(incomingPrepayment, 'edit')) incomingPrepayment.editItem = true;
    };

    vm.sendNotification = function (incomingPrepayment) {
      incomingPrepayment.notification = false;

      //Mean while it is added the notifications to clients
      IncomingPrepaymentService.saveIncomingPrepayment(incomingPrepayment, 'reminder').then(
        function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            getPrepayments('get');
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        }
      );
    };

    vm.closeEdit = function (incomingPrepayment, index) {
      incomingPrepayment.editItem = false;
      setIncomingPrepayment(index);
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      getPrepayments();
    };

    vm.$onInit = function () {
      vm.originalItems = angular.copy(vm.incomingPrepayments);
      setIncomingPrepaymentTotals('sum');
      setPrePaymentDatePicker();
    };

    function getPrepayments(mode = 'get') {
      vm.filterCriteria.by_booking_id = vm.item.id;

      IncomingPrepaymentService.getPrepayments(vm.filterCriteria).then(function (data) {
        vm.originalItems = angular.copy(data.items);

        if (mode === 'get') {
          vm.incomingPrepayments = data.items.sort((a, b) => (a.due_date > b.due_date ? 1 : -1));
        }

        setIncomingPrepaymentTotals(mode === 'get' ? 'sum' : 'edit');
      });
    }

    function setIncomingPrepaymentTotals(type) {
      vm.totalPaymentReceived = 0;
      vm.totalOutstandingBalance = 0;
      vm.totalPercentage = 0;
      vm.totalAmount = 0;
      vm.totalBalance = 0;

      vm.incomingPrepayments.forEach(function (incomingPrepayment) {
        incomingPrepayment.company_id = vm.company.id;
        incomingPrepayment.receivedAmount = incomingPrepayment.received_payment_documents.reduce(
          (totalAmount, document) => totalAmount + document.amount,
          0
        );
        incomingPrepayment.balance_due = incomingPrepayment.balance_due || 0;

        if (type === 'sum') incomingPrepayment.editItem = false;

        vm.totalPaymentReceived += vm.UtilService.roundNum(incomingPrepayment.receivedAmount);
        vm.totalBalance += vm.UtilService.roundNum(incomingPrepayment.balance_due);
        vm.totalAmount += vm.UtilService.roundNum(incomingPrepayment.amount);
        vm.totalPercentage += vm.UtilService.roundNum(incomingPrepayment.percentage);
      });

      // vm.originalItems = angular.copy(vm.incomingPrepayments);

      vm.totalOutstandingBalance = vm.UtilService.roundNum(
        vm.item.total_price - vm.totalPaymentReceived
      );
    }

    function validateEditDelete(incomingPrepayment, type) {
      let cannotEdit = false;
      let modalParams = {
        title: 'WARNING',
        body: null,
      };

      if (vm.item.status === 'closed') {
        cannotEdit = true;
        modalParams.body =
          type === 'edit' ? 'EDIT_PREPAYMENT_BOOKING_CLOSED' : 'DELETE_PREPAYMENT_BOOKING_CLOSED';
      } else if (incomingPrepayment.status === 'completed') {
        cannotEdit = true;
        modalParams.body = type === 'edit' ? 'EDIT_PREPAYMENT_PENDING' : 'DELETE_PREPAYMENT_EDIT';
      }

      if (cannotEdit) vm.UtilService.warningMsg(modalParams, null, null);

      return !cannotEdit;
    }

    function setIncomingPrepayment(index) {
      vm.incomingPrepayments[index] = angular.copy(vm.originalItems[index]);
      setIncomingPrepaymentTotals('edit');
    }

    function setPrePaymentDatePicker() {
      vm.prepaymentDatePickerOptions = {
        singleDatePicker: true,
        maxDate: moment(vm.item.start_date),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'apply.daterangepicker': function (ev, picker) {
            // Clear invalid input
            let todayDate = moment(new Date()).format('YYYY-MM-DD');
            vm.sendingForm = false;

            if (
              vm.incomingPrepayments.filter(
                (incomingPrepayment) =>
                  moment(incomingPrepayment.due_date).format('YYYY-MM-DD') ===
                  moment(ev.model._d).format('YYYY-MM-DD')
              ).length > 1
            ) {
              vm.UtilService._errorMsg($translate('IS_NOT_ALLOW_SAME_CONFIG'));
              vm.sendingForm = true;
            }

            let dateCalculated = moment(ev.model._d).format('YYYY-MM-DD');
            if (dateCalculated <= todayDate) {
              vm.UtilService._errorMsg($translate('DATE_WARNING'));
              vm.sendingForm = true;
            }
          },
        },
      };
    }

    function validatePercentage() {
      return vm.incomingPrepayments.reduce(
        (totalPercentage, prepayment) => totalPercentage + prepayment.percentage,
        0
      );
    }
  }
})();
